import { render, staticRenderFns } from "./AcknowledgementsModal.vue?vue&type=template&id=29a5c239&scoped=true&"
import script from "./AcknowledgementsModal.vue?vue&type=script&lang=js&"
export * from "./AcknowledgementsModal.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgementsModal.vue?vue&type=style&index=0&id=29a5c239&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a5c239",
  null
  
)

export default component.exports